import store from '../../store'
import dialogs from '../common/dialogs'
import formats from '../../api/formats'
import vDocNew from './DocNew.vue'
import vDocForm from './DocForm.vue'
import vDocSelector from '../depo/DocSelector'
import vDocPropSelector from '../depo/DocPropSelector'
import vDocPropList from '../depo/DocPropList'

export default {
  newFile (path, onSelect, id, tags) {
    dialogs.register('v-doc-new', vDocNew)
    var comp = { template: `
      <v-doc-new toolbar :fileItemId="dialogItemId" :newPath="path" :newTags="tags" v-on:input="onSelect" v-on:close="$emit('close')"></v-doc-new>
      `,
      data () {
        return {
          dialogItemId: id,
          path: path,
          tags: tags,
          onSelect: onSelect || (() => {})
        }
      }
    }
    dialogs.modal(comp)
  },
  openFile (id, path, readonly, onNewVersion, exactVersion) {
    dialogs.register('v-doc-form', vDocForm)
    var comp = { template: `
      <v-doc-form toolbar :fileItemId="dialogItemId" :readonly="readonly" :newPath="path" v-on:close="$emit('close')"
      v-on:new-version="onNewVersion" :exactVersion="exactVersion"
      > </v-doc-form>
      `,
      data () {
        return {
          dialogItemId: id,
          path: path,
          readonly: readonly && readonly === true,
          exactVersion: exactVersion && exactVersion === true,
          onNewVersion: onNewVersion || (() => {})
        }
      }
    }
    dialogs.modal(comp)
  },
  createPreview (item, cxt) {
    const vIcon = (name) => `<v-icon @click.stop="self.openFile(item.uid)">${name}</v-icon>`
    var template = null

    switch (item.fileExt) {
      case '.jpg':
      case '.jpeg':
      case '.png':
      case '.gif':
        template = `<img :src="self.getDepoUrl(item.uid) + '/preview?width=100'" @click.stop="self.openFile(item.uid)"/>`
        break
      case '.pdf':
        template = vIcon('dealger-file-pdf')
        break
      case '.doc':
      case '.docx':
        template = vIcon('dealger-file-word')
        break
      case '.xls':
      case '.xlsx':
        template = vIcon('dealger-file-excel')
        break
      default:
        template = vIcon('dealger-file-empty')
    }
    return {
      template: template,
      data: function () {
        return {
          self: cxt,
          item: item
        }
      }
    }
  },
  selectDoc (cxt, onSelect, multi, queryCxt) {
    dialogs.register('v-doc-selector', vDocSelector)
    var fullscreen = store.getters.getIsMobile
    var comp = { template: `
      <v-doc-selector :queryCxt="queryCxt" :fullscreen="fullscreen" :radio="radio" v-on:input="setDoc" v-on:close="$emit('close')"></v-doc-selector>
    `,
      data () {
        return {
          setDoc: onSelect,
          fullscreen: fullscreen,
          radio: !multi,
          queryCxt: queryCxt
        }
      }
    }
    dialogs.modal(comp)
  },
  selectDocProp (cxt, onSelect, items, selected, title) {
    dialogs.register('v-docprop-selector', vDocPropSelector)
    var fullscreen = store.getters.getIsMobile
    var comp = { template: `
      <v-docprop-selector :fullscreen="fullscreen" :items="items" :selected="selected" :title="title" v-on:input="onSelect" v-on:close="$emit('close')"></v-docprop-selector>
    `,
      data () {
        return {
          selected: selected,
          onSelect: onSelect,
          fullscreen: fullscreen,
          items: items,
          title: title
        }
      }
    }
    dialogs.modal(comp)
  },
  openDocProps (companyRefCode, docprops) {
    return new Promise((resolve, reject) => {
      dialogs.register('v-docprop-list', vDocPropList)
      const onInput = (data) => {
        resolve(data)
      }
      let title = 'Список документов'
      let fullscreen = store.getters.getIsMobile
      let comp = { template: `
        <v-docprop-list :fullscreen="fullscreen" :companyRefCode="companyRefCode" :docprops="docprops" :title="title" v-on:input="onSelect" v-on:close="$emit('close')"></v-docprop-list>
      `,
        data () {
          return {
            onSelect: onInput,
            fullscreen: fullscreen,
            companyRefCode: companyRefCode,
            docprops: docprops,
            title: title
          }
        }
      }
      dialogs.modal(comp)
    })
  },
  downloadFile (url) {
    var element = document.createElement('a')
    element.setAttribute('href', url)
    element.setAttribute('download', '')
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  },
  getDepoFilesUrl (ids) {
    return store.getters.getDepoFilesUrl(ids)
  },
  downloadFiles (ids) {
    var link = this.getDepoFilesUrl(ids)
    this.downloadFile(link)
  },
  sendProps (ids, email, emailProp) {
    const printProps = f => {
      return `Документ: ${f.docName}${f.signed ? '\n\t' + store.getters.renderDepoFileSignMessage(f) : ''}
      \tCсылка: ${store.getters.getDepoUrl(f.uid)}
      \tДепонировано: ${formats.formatDateTime(f.uploaded)} (по: ${formats.formatDate(f.deleted)})
      \tДепонент: ${f.ownerShortName} ИНН: ${formats.formatInn(f.ownerInn)}\n`
    }
    const prepareList = data => {
      var filePropText = `\n` + data.map(i => {
        return printProps(i)
      }).join(`\n`)
      var downloads = `\n Скачать все: ${store.getters.getDepoFilesUrl(ids)}`
      var sign = `${store.getters.getProfile.nameShort}\n\n${store.getters.getProfile.clientNameShort} \n ИНН ${store.getters.getProfile.clientInn}`
      var subject = emailProp && emailProp.subject ? emailProp.subject : 'Список ссылок на документы'
      var intro = emailProp && emailProp.body ? emailProp.body : 'Добрый день,\nНаправляю Вам ссылки для скачивания следующих документов:'
      var emailBody = ''.concat(
        intro,
        '\n',
        filePropText,
        '\n',
        downloads,
        '\n',
        '\n',
        'С уважением,',
        '\n',
        sign
      )
      store.dispatch('shareTo', {email: email, subject: subject, emailBody: emailBody})
    }
    store.dispatch('getDepoFileProps', {uids: ids}).then(data => prepareList(data))
  },
  sendPropsByServer (ids, email, emailProp, asAttach) {
    return new Promise((resolve, reject) => {
      const printProps = f => {
        return `Документ: ${f.docName}${f.signed ? '\n\t' + store.getters.renderDepoFileSignMessage(f) : ''}
        \tCсылка: ${store.getters.getDepoUrl(f.uid)}
        \tДепонировано: ${formats.formatDateTime(f.uploaded)} (по: ${formats.formatDate(f.deleted)})
        \tДепонент: ${f.ownerShortName} ИНН: ${formats.formatInn(f.ownerInn)}\n`
      }
      const prepareList = data => {
        var filePropText = `\n` + data.map(i => {
          return printProps(i)
        }).join(`\n`)
        var downloads = `\n Скачать все: ${store.getters.getDepoFilesUrl(ids)}`
        var sign = `${store.getters.getProfile.nameShort}\n\n${store.getters.getProfile.clientNameShort} \n ИНН ${store.getters.getProfile.clientInn}`
        var subject = emailProp && emailProp.subject ? emailProp.subject : 'Список ссылок на документы'
        var intro = emailProp && emailProp.body ? emailProp.body : 'Добрый день,\nНаправляю Вам ссылки для скачивания следующих документов:'
        var emailBody = ''.concat(
          intro,
          '\n',
          filePropText,
          '\n',
          downloads,
          '\n',
          '\n',
          'С уважением,',
          '\n',
          sign
        )
        console.log('sendPropsByServer', asAttach ? ids : null)
        store.dispatch('sendTo', {email: email, subject: subject, body: emailBody, uids: asAttach ? ids : null})
          .then((data) => resolve(data))
      }
      store.dispatch('getDepoFileProps', {uids: ids}).then(data => prepareList(data))
    })
  },
  getPropsText (ids, body, subject) {
    return new Promise((resolve, reject) => {
      const printProps = f => {
        return `Документ: ${f.docName}${f.signed ? '\n\t' + store.getters.renderDepoFileSignMessage(f) : ''}
        \tCсылка: ${store.getters.getDepoUrl(f.uid)}
        \tДепонировано: ${formats.formatDateTime(f.uploaded)} (по: ${formats.formatDate(f.deleted)})
        \tДепонент: ${f.ownerShortName} ИНН: ${formats.formatInn(f.ownerInn)}\n`
      }
      const prepareList = data => {
        var filePropText = `\n` + data.map(i => {
          return printProps(i)
        }).join(`\n`)
        var downloads = `\n Скачать все: ${store.getters.getDepoFilesUrl(ids)}`
        var sign = `${store.getters.getProfile.nameShort}\n\n${store.getters.getProfile.clientNameShort} \n ИНН ${store.getters.getProfile.clientInn}`
        var emailSubject = subject || 'Список ссылок на документы'
        var intro = body || 'Добрый день, Направляю Вам ссылки для скачивания следующих документов:'
        var emailBody = ''.concat(
          intro,
          '\n',
          filePropText,
          '\n',
          downloads,
          '\n',
          '\n',
          'С уважением,',
          '\n',
          sign
        )
        resolve({subject: emailSubject, body: emailBody, uids: ids})
      }
      store.dispatch('getDepoFileProps', {uids: ids}).then(data => prepareList(data))
    })
  },
  getPropsHtml (ids, body, subject, signature) {
    return new Promise((resolve, reject) => {
      const printProps = f => {
        return `Документ: <a href="${store.getters.getDepoUrl(f.uid)}">${f.docName}</a>
        <p style="margin-left: 40px">
        ${f.signed ? store.getters.renderDepoFileSignMessage(f) : ''}
        Депонировано: ${formats.formatDateTime(f.uploaded)} (по: ${formats.formatDate(f.deleted)}) <br>
        Депонент: ${f.ownerShortName} ИНН: ${formats.formatInn(f.ownerInn)} 
        </p>`
      }
      const prepareList = data => {
        var filePropText = `\n` + data.map(i => {
          return printProps(i)
        }).join(`<br>`)
        var downloads = `<a href="${store.getters.getDepoFilesUrl(ids)}">Скачать все</a>`
        var sign = signature || `${store.getters.getProfile.nameShort}<br><br>${store.getters.getProfile.clientNameShort}  <br> ИНН ${store.getters.getProfile.clientInn}`
        var emailSubject = subject || 'Список ссылок на документы'
        var intro = body || 'Добрый день, <p style="margin-left: 40px"> Направляю Вам ссылки для скачивания следующих документов: </p>'
        var emailBody = ''.concat(
          intro,
          filePropText,
          downloads,
          '<br>',
          '<br>',
          sign
        )
        resolve({subject: emailSubject, body: emailBody, uids: ids})
      }
      store.dispatch('getDepoFileProps', {uids: ids}).then(data => prepareList(data))
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/depo/index.js